import { render, staticRenderFns } from "./OriginTable.vue?vue&type=template&id=edcada86&scoped=true"
import script from "./OriginTable.vue?vue&type=script&lang=js"
export * from "./OriginTable.vue?vue&type=script&lang=js"
import style0 from "./OriginTable.vue?vue&type=style&index=0&id=edcada86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcada86",
  null
  
)

export default component.exports